import React, { useEffect, useState } from "react";
import MainLayout from "../../layout/mainLayout";
import "./index.scss";
import HomeBanner from "./components/homeBanner";
import IndemnityCard from "./components/productCard";
import OtherInsuranceCard from "./components/otherInsuranceCard";
import BlogCard from "./components/blog/blogCard";
import { getProductListing } from "../../service/product/productService";
import { useSelector } from "react-redux";
import {
  formatAmount,
  getCodeFromUrl,
  setParamsInURL,
} from "../../utils/helper";
import AlertCard from "./components/alertCard";
import dateFormat from "dateformat";
import {
  blogList,
  buyNow,
  ordersDetails,
  paymentSummary,
  profile,
  renewalDetails,
} from "../../utils/router/constant";
import { useLocation, useNavigate } from "react-router-dom";
import Timer from "../../assets/images/timer.gif";
import WatchTimer from "../../assets/images/watchTimer.gif";
import { getRenewalListing } from "../../service/renewal/renewalService";
import RMCard from "../../components/rmCard";
import { api_strapi } from "../../utils/interface";
import { getOrdersData } from "../../service/order/orderService";
import { ArrowRightPrimary } from "../../assets/images/svg/svg";
import InsuranceDetails from "../orders/component/orderCards/components";
import ComingSoonBanner from "../../components/common/banner";
import ProductBanner from "./components/productBanner";

const Home = () => {
  const [insuranceCard, setInsuranceCard] = useState([]);
  const [insuranceId, setInsuranceId] = useState();
  const [blogs, setBlogs] = useState([]);
  const InsuranceCardsData = useSelector((state) => state.product.productData);
  const [otherInsurance, setOtherInsurance] = useState([]);
  const isFirstLogin = useSelector((state) => state.common.isFirstLogin);
  const renewalData = useSelector((state) => state.renewal.renewalData);
  const ordersData = useSelector((state) => state.orders?.ordersData || []);

  // const firstPolicy = renewalData?.[0];
  const location = useLocation();
  const nav = useNavigate();

  // const value = useSelector((state) => state.common.agName?.toLowerCase());
  let agCode = getCodeFromUrl();
  const [filter, setFilter] = useState({});
  const [showAllAlerts, setShowAllAlerts] = useState(false);

  useEffect(() => {
    getProductListing();
    getRenewalListing();
    // getOrdersData();
    getOrdersData(filter);
  }, [filter]);

  useEffect(() => {
    const getHomePage = async () => {
      if (agCode) {
        const homeResponse = await api_strapi.get(
          `/homes?filters[slug][$eq]=${agCode}&populate=otherInsurance,otherInsurance.cardImg,otherInsurance.insuranceBtn`,
        );
        let id;
        if (homeResponse && homeResponse.status === 200) {
          id = homeResponse?.data?.data[0]?.id;
          setInsuranceCard(
            homeResponse?.data?.data[0]?.attributes?.otherInsurance?.map(
              (card) => ({
                desc: card?.desc,
                img: card?.cardImg?.data?.attributes?.url,
                btnTitle: card?.insuranceBtn?.btnTitle,
                btnLink: card?.insuranceBtn?.btnLink,
                isRedirection: card?.insuranceBtn?.isRedirection,
              }),
            ),
          );
          setInsuranceId(id);
        }

        const blogResponse = await api_strapi.get(`/blogs/getByHome/${id}`);

        if (blogResponse && blogResponse?.status === 200) {
          setBlogs(
            blogResponse?.data?.map((blog) => ({
              blogTitle: blog?.blogTitle,
              imageUrl: blog?.blogHeadingImage.map((img) => ({
                url: img?.image?.url,
              })),
              shortDescription: blog?.shortDescription,
              blogSlug: blog?.blogSlug,
            })),
          );
        }
      }

      const insuranceResponse = await api_strapi.get(`/insurances?populate=*`);
      if (insuranceResponse && insuranceResponse.status === 200) {
        setOtherInsurance(
          insuranceResponse?.data?.data?.map((ins) => ({
            title: ins?.attributes?.title,
            img: ins?.attributes?.img?.data?.attributes?.url,
            btn: ins?.attributes?.btn?.btnTitle,
            id: ins?.attributes?.form_modal?.data?.id,
            redirectURL: ins?.attributes?.btn?.redirectURL,
          })),
        );
      }
    };
    getHomePage();
  }, [agCode]);

  const viewALLBlogs = () => {
    return nav(`${blogList}/${insuranceId}`);
  };

  const handleRenew = async (entityid, orderId) => {
    const paramObject = {
      entityid: entityid,
      orderId: orderId,
    };

    const params = await setParamsInURL(location, paramObject);
    nav(`${renewalDetails}?${params}`);
  };

  const handleOrderContinue = async (orderData) => {
    if (!orderData || !orderData.status) return;

    let path = buyNow;
    let paramObject = {
      entityid: orderData.product_id,
      orderId: orderData.entityid,
    };

    if (orderData.product_type_name === "UMBRELLA" && orderData.redirect_url) {
      switch (orderData.status) {
        case "PROPOSAL_PENDING":
          paramObject.tabIndex = 0;
          break;
        case "PAYMENT_PENDING":
        case "PAYMENT_FAILED":
          window.location.href = `${orderData.redirect_url}`;
          return;
        case "PAYMENT_SUCCESS":
          paramObject.tabIndex = 0;
          break;
        default:
          return;
      }
    } else {
      switch (orderData.status) {
        case "PROPOSAL_PENDING":
          paramObject.tabIndex = 0;
          break;
        case "PAYMENT_PENDING":
          if (orderData.proposal_filled === 0) {
            paramObject.tabIndex = 0;
          } else {
            path = paymentSummary;
          }
          break;
        case "PAYMENT_FAILED":
          path = paymentSummary;
          break;
        default:
          return;
      }
    }

    const params = await setParamsInURL(location, paramObject);
    nav(`${path}?${params}`);
  };

  const getCoverValue = (orderData) => {
    let cover = 0;

    if (orderData && orderData.variant_json) {
      const data = JSON.parse(orderData.variant_json);
      const firstId = Object.keys(data)[0];

      if (firstId && data[firstId]?.cover) {
        cover = data[firstId].cover;
      }
    }
    return formatAmount(cover);
  };

  const getAllAlerts = () => {
    const alerts = [];

    if (isFirstLogin) {
      alerts.push(
        <AlertCard
          key="profile-incomplete"
          percentage={isFirstLogin ? "20" : "100"}
          title="Your Profile is incomplete!"
          subtitle="You have left your profile incomplete, inaccessible to the plans offered by us. Please complete your profile to get the best plans."
          redirectlink={profile}
        />,
      );
    }

    if (renewalData) {
      renewalData.forEach((order) => {
        if (order?.renewal_remaining_days) {
          alerts.push(
            <AlertCard
              key={`renewal-${order?.code}`}
              gifSrc={Timer}
              cardType="RENEWAL"
              title="Your Subscription is up for Renewal!"
              subtitle={
                <>
                  Your Product <strong>{order?.name}</strong> is up for Renewal!
                </>
              }
              handleClick={() => handleRenew(order.product_id, order.entityid)}
              orderId={order?.code}
              premiumAmount={formatAmount(order?.gross_amount)}
              cover={getCoverValue(order)}
              validTill={
                order?.renewal_end_date
                  ? dateFormat(order?.renewal_end_date, "dd/mm/yyyy")
                  : "-"
              }
              daysLeft={`${order?.renewal_remaining_days} days left`}
            />,
          );
        } else if (order?.renewal_grace_remaining_days) {
          alerts.push(
            <AlertCard
              key={`grace-${order?.code}`}
              gifSrc={WatchTimer}
              title="Grace Period Alert for Policy Renewal!"
              subtitle={
                <>
                  Get your <strong>{order?.name}</strong> policy renewal done to
                  avoid cover lapse.
                </>
              }
              handleClick={() =>
                handleRenew(order?.product_id, order?.entityid)
              }
              orderId={order?.code}
              premiumAmount={formatAmount(order?.gross_amount)}
              cover={getCoverValue(order)}
              validTill={
                order?.renewal_end_date
                  ? dateFormat(order?.renewal_end_date, "dd/mm/yyyy")
                  : "-"
              }
              daysLeft={`lapse in ${order?.renewal_grace_remaining_days} days`}
              type={true}
            />,
          );
        }
      });
    }

    if (ordersData) {
      ordersData.forEach((order) => {
        if (
          order?.status === "PAYMENT_PENDING" &&
          order?.order_type === "FRESH"
        ) {
          alerts.push(
            <AlertCard
              key={`pending-${order?.code}`}
              gifSrc={WatchTimer}
              cardType="PAYMENT_PENDING"
              title="Payment Pending!"
              subtitle={
                <>
                  Your payment for <strong>{order?.name}</strong> is still
                  pending.
                </>
              }
              handleClick={() => handleOrderContinue(order)}
              orderId={order?.code}
              premiumAmount={formatAmount(order?.gross_amount)}
              cover={formatAmount(order?.cover_amount)}
            >
              {/* Additional details section */}
            </AlertCard>,
          );
        }
      });
    }

    return alerts;
  };

  const allAlerts = getAllAlerts();

  return (
    <MainLayout>
      <div className="home--container">
        <div className="row">
          <div className="col-lg-3 col-12 order-lg-2 d-none d-lg-block">
            <div className="home--widget">
              <RMCard />
              {/* <Widgets /> */}
            </div>
          </div>
          <div className="col-lg-9 col-12 order-lg-1">
            <div className="home--content--body">
              {allAlerts.length > 0 && (
                <>
                  {showAllAlerts ? allAlerts : allAlerts.slice(0, 1)}
                  {allAlerts.length > 1 && (
                    <div className="view-more-container d-flex justify-content-end mb-3">
                      <button
                        className="view-all"
                        onClick={() => setShowAllAlerts(!showAllAlerts)}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#0056b3",
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        {showAllAlerts ? "View Less" : "View More"}
                      </button>
                    </div>
                  )}
                </>
              )}

              <HomeBanner />
              <div className="d-block d-lg-none">
                <div className="home--widget">
                  <RMCard />
                </div>
              </div>
              <div className="home--content__indemnity">
                <h1 className="home--title">Products</h1>
                <div className="row home--content--wrapper">
                  {InsuranceCardsData.map((data, index) => (
                    <div key={index} className="col-xl-4 col-sm-6 col-10 my-3">
                      <IndemnityCard {...data} entityid={data.entityid} />
                    </div>
                  ))}
                  {InsuranceCardsData.length === 1 && (
                    <div className="col-xl-8 col-sm-6 col-10">
                      <ProductBanner />
                    </div>
                  )}
                </div>
              </div>
              <div className="home--content__otherinsurance">
                <h1 className="home--title">Other Insurance</h1>
                <div className="row home--content--wrapper">
                  {otherInsurance?.map((data, index) => (
                    <div
                      key={index}
                      className="col-xl-3 col-md-4 col-sm-6 col-10"
                    >
                      <OtherInsuranceCard {...data} />
                    </div>
                  ))}
                </div>
              </div>
              <div className="home--content__blogs">
                <div className="home--header">
                  <h1 className="home--title">Blogs & Articles</h1>
                  {blogs.length > 3 && (
                    <button className="view-all" onClick={() => viewALLBlogs()}>
                      View All
                    </button>
                  )}
                </div>
                <div className="row home--content--wrapper">
                  {blogs.slice(0, 3)?.map((data, index) => (
                    <div key={index} className="col-xl-4 col-sm-6 col-10">
                      <BlogCard {...data} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Home;
